export const COPYRIGHT = 'Copyright © KOREA MANAGEMENT GROUP. All Rights Reserved.';
